import {
  CHAT_DETAIL,
  CHAT_DETAIL_LOADING,
  CHAT_ERROR,
  CHAT_LIST,
  CHAT_LOADING,
  CHAT_MARK_MESSAGES_READ,
  CHAT_MESSAGE_SENT,
  CHAT_MESSAGES,
  CHAT_MESSAGES_LOADING,
  CHAT_SEND_LOADING,
  CHAT_SOCKET_READY,
  CHAT_MESSAGE_RECEIVED,
  CHAT_UNREAD_COUNT,
} from "../actions/type";

const initialState = {
  items: [],
  vendorProfile: null,
  pagination: { page: 1, limit: 20, total: 0, totalPages: 1 },
  loading: false,
  error: "",
  detail: null,
  detailLoading: false,
  messagesByChat: {},
  messagesPaginationByChat: {},
  messagesLoadingByChat: {},
  sendLoadingByChat: {},
  socketReadyByChat: {},
  unreadCount: 0,
};

const sortMessages = (messages) =>
  [...messages].sort((left, right) => {
    const leftTime = new Date(left.createdAt).getTime();
    const rightTime = new Date(right.createdAt).getTime();
    if (Number.isNaN(leftTime) || Number.isNaN(rightTime)) return 0;
    return leftTime - rightTime;
  });

export default function chat(state = initialState, action) {
  switch (action.type) {
    case CHAT_LIST:
      return { ...state, ...action.payload };
    case CHAT_LOADING:
      return { ...state, loading: action.payload };
    case CHAT_ERROR:
      return { ...state, error: action.payload };
    case CHAT_UNREAD_COUNT:
      return { ...state, unreadCount: action.payload };
    case CHAT_MARK_MESSAGES_READ: {
      const inquiryId = String(action.payload.inquiryId);
      const matchingChats = state.items.filter(
        (item) =>
          String(item.inquiryMongoId || "") === inquiryId ||
          String(item.inquiryId || "") === inquiryId,
      );
      const unreadToClear = matchingChats.reduce(
        (total, item) => total + (Number(item.unread) || 0),
        0,
      );
      return {
        ...state,
        unreadCount: Math.max(0, (Number(state.unreadCount) || 0) - unreadToClear),
        items: state.items.map((item) =>
          String(item.inquiryMongoId || "") === inquiryId ||
          String(item.inquiryId || "") === inquiryId
            ? { ...item, unread: 0 }
            : item,
        ),
      };
    }
    case CHAT_DETAIL:
      return { ...state, detail: action.payload };
    case CHAT_DETAIL_LOADING:
      return { ...state, detailLoading: action.payload };
    case CHAT_MESSAGES: {
      const { inquiryId, page, items, pagination, requestStartedAt } = action.payload;
      const previous = state.messagesByChat[inquiryId] || [];
      const messagesReceivedDuringRequest = previous.filter((message) => {
        const createdAt = new Date(message.createdAt).getTime();
        return Number.isFinite(createdAt) && createdAt >= requestStartedAt;
      });
      const combined =
        page > 1
          ? [...items, ...previous]
          : [...items, ...messagesReceivedDuringRequest];
      const unique = combined.filter(
        (message, index, list) =>
          list.findIndex((entry) => entry.id === message.id) === index,
      );
      return {
        ...state,
        messagesByChat: {
          ...state.messagesByChat,
          [inquiryId]: sortMessages(unique),
        },
        messagesPaginationByChat: {
          ...state.messagesPaginationByChat,
          [inquiryId]: pagination,
        },
      };
    }
    case CHAT_MESSAGES_LOADING:
      return {
        ...state,
        messagesLoadingByChat: {
          ...state.messagesLoadingByChat,
          [action.payload.inquiryId]: action.payload.loading,
        },
      };
    case CHAT_SEND_LOADING:
      return {
        ...state,
        sendLoadingByChat: {
          ...state.sendLoadingByChat,
          [action.payload.inquiryId]: action.payload.loading,
        },
      };
    case CHAT_SOCKET_READY:
      return {
        ...state,
        socketReadyByChat: {
          ...state.socketReadyByChat,
          [action.payload.inquiryId]: action.payload.ready,
        },
      };
    case CHAT_MESSAGE_SENT:
    case CHAT_MESSAGE_RECEIVED: {
      const { inquiryId, message } = action.payload;
      const previous = state.messagesByChat[inquiryId] || [];
      const existing = previous.some((item) => item.id === message.id);
      const lastMessage = [
        message.text,
        message.attachment?.fileName
          ? `Attachment: ${message.attachment.fileName}`
          : "",
      ]
        .filter(Boolean)
        .join(" · ");
      const updatedChats = state.items.map((item) =>
        item.inquiryId === inquiryId
          ? {
              ...item,
              lastMessage,
              time: message.time,
              unread: 0,
            }
          : item,
      );
      return {
        ...state,
        items: updatedChats,
        messagesByChat: {
          ...state.messagesByChat,
          [inquiryId]: existing
            ? previous
            : sortMessages([...previous, message]),
        },
      };
    }
    default:
      return state;
  }
}
